<style scoped lang="scss">
    .empty-image-wrap{
        .empty-image{
            width: 134px;
            height: 71px;
            /*background: url(/images/empty-page.png?3e21520cefc165358d32934e95303a80) no-repeat center;*/
            background-size: 100%;
            margin: auto;
        }
        p{
            margin-top: 15px;
            font-size: 1.4rem;
            line-height: 14px;
            letter-spacing: -0.73px;
            color: #7c7c7c;
        }

    }
</style>
<template>
    <div class="group-result-ranking-wrap" v-if="ranks && ranks.participantList.length > 0">
        <p class="sub-title">조별순위</p>
        <div class="table-wrap">
            <table v-if="!loadingcheck && playCheck && playCheck.resultCount > 0">
                <tr>
                    <th rowspan="2" width="40px">순위</th>
                    <th rowspan="2" width="80px">팀이름</th>
                    <th rowspan="2" width="30">승</th>
                    <th rowspan="2" width="30">패</th>
                    <th v-if="ranks && ranks.participantList[0].sumMatchPoint != null" colspan="3">Match</th>
                    <th colspan="3">Game</th>
                    <th colspan="3">Point</th>
                </tr>
                <tr>
                    <th v-if="ranks && ranks.participantList[0].sumMatchPoint != null" width="30" style="top: 35px ">득</th>
                    <th v-if="ranks && ranks.participantList[0].sumMatchPoint != null" width="30" style="top: 35px">실</th>
                    <th v-if="ranks && ranks.participantList[0].sumMatchPoint != null" width="30" style="top: 35px">차</th>
                    <th width="30" style="top: 35px">득</th>
                    <th width="30" style="top: 35px">실</th>
                    <th width="30" style="top: 35px">차</th>
                    <th width="30" style="top: 35px">득</th>
                    <th width="30" style="top: 35px">실</th>
                    <th width="30" style="top: 35px">차</th>
                </tr>
                <tr v-for="(participant, participantIndex) in ranks.participantList" :key="participant.participantId">
                    <td width="40">{{participantIndex+1}}</td>
                    <td width="100">
                        <p>
                            <span v-if="participant.participantName != participant.userList[0].playerName">{{participant.participantName}}<br/></span>
                            <span v-for="user in participant.userList" :key="user.playerId">{{user.playerName}} </span>
                        </p>
                    </td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.winCount}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.defeatCount}}</td>
                    <td v-if="matches && matches.participantList.length > 0 && ranks && ranks.participantList[0].sumMatchPoint != null">{{participant.matchGotPoint}}</td>
                    <td v-if="matches && matches.participantList.length > 0 && ranks && ranks.participantList[0].sumMatchPoint != null">{{participant.matchLostPoint}}</td>
                    <td v-if="matches && matches.participantList.length > 0 && ranks && ranks.participantList[0].sumMatchPoint != null">{{participant.sumMatchPoint}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.gameWinCount}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.gameLostCount}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.sumGameCount}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.subGotPoint}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.subLostPoint}}</td>
                    <td v-if="matches && matches.participantList.length > 0">{{participant.subSumPoint}}</td>
                </tr>
            </table>
            <table v-else>
                <tr>
                    <th rowspan="2" width="40">번호</th>
                    <th rowspan="2" width="100">팀이름</th>
                    <th rowspan="2">승</th>
                    <th rowspan="2">패</th>
                    <th colspan="3">Match</th>
                    <th colspan="3">Game</th>
                    <th colspan="3">Point</th>
                    <th rowspan="2">순위</th>
                </tr>
                <tr>
                    <th style="top: 35px">득</th>
                    <th style="top: 35px">실</th>
                    <th style="top: 35px">차</th>
                    <th style="top: 35px">득</th>
                    <th style="top: 35px">실</th>
                    <th style="top: 35px">차</th>
                    <th style="top: 35px">득</th>
                    <th style="top: 35px">실</th>
                    <th style="top: 35px">차</th>
                </tr>

                <tr v-for="(participant, participantIndex) in ranks.participantList" :key="participant.participantId">
                    <td width="40">{{participantIndex+1}}</td>
                    <td width="100">
                        <p>
                            {{participant.participantName}}<br/>
                            <span v-for="user in participant.userList" :key="user.playerId">{{user.playerName}} </span>
                        </p>
                    </td>
                    <td colspan="6" :rowspan="ranks.participantList.length" v-if="participantIndex===0">
                        <empty-content content="경기예정" style="height: 100%; width: 100%"></empty-content>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";
    // import EmptyContent from "../../common/EmptyContent";
    export default{
        components: {EmptyContent},
        // components: {EmptyContent},
        props: ['group_id'],
        computed: {
          ...mapState('tournaments', ['matches', 'ranks', 'playCheck'])
        },
        watch: {
          group_id: function(newVal){
              this.groupId = newVal
          }
        },
        data(){
            return{
                groupId: this.group_id,
                loadingcheck: false
            }
        },
        created() {
            const tnmtId = this.$route.params.tnmtId
            const playingCategoryId = this.$route.params.playingCategoryId

            const _this = this
            this.loadingcheck = true

            this.$store.dispatch('tournaments/getGroupMatchPlayCheck', {
                tnmtId: tnmtId,
                playingCategoryId: playingCategoryId,
                groupId: this.groupId
            }).then(res => {
                console.dir(res)
                _this.loadingcheck = false
            }).catch(err => {
                _this.loadingcheck = false
            })
        }
    }
</script>
